var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Menu'),_c('transition',{attrs:{"name":"animate"}},[_c('router-view')],1),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h6',[_vm._v("Designed by Brittany Foster"),_c('br'),_vm._v("Developed by "),_c('a',{attrs:{"href":"https://www.linkedin.com/in/steven-ray-simon","target":"_blank"}},[_vm._v("Steven Simon")])])
}]

export { render, staticRenderFns }